/* unplugin-vue-components disabled */import { render } from "./SaleFormProp.vue?vue&type=template&id=218ac164&scoped=true&ts=true"
import script from "./SaleFormProp.vue?vue&type=script&lang=ts"
export * from "./SaleFormProp.vue?vue&type=script&lang=ts"

import "./SaleFormProp.vue?vue&type=style&index=0&id=218ac164&lang=less&scoped=true"

import exportComponent from "D:\\项目\\blueSkyReportForm\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-218ac164"]])

export default __exports__